import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Power.svg",
  "use": "Power.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Power.svg\"><path d=\"M32.01,56.0274a24.05,24.05,0,0,1-13.8864-43.651,2.0014,2.0014,0,0,1,2.281,3.2894,20,20,0,1,0,23.21,0,2.0015,2.0015,0,0,1,2.2813-3.2894A24.05,24.05,0,0,1,32.01,56.0274Zm0-26.0066a2,2,0,0,1-2-2v-22a2,2,0,0,1,4,0v22A2,2,0,0,1,32.01,30.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol